import { AssetDeletedEvent } from '../event/asset-deleted.event';
const assetDeletedProjections = {
    [AssetDeletedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            deleted: payload.deleted,
        };
    },
};
export default assetDeletedProjections;
//# sourceMappingURL=asset-deleted.projection.js.map